import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeDescription',
  standalone: true // Standalone pipe
})
export class TypeDescriptionPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'PCDTEMPORARY': return 'PCD temporária';
      case 'PCDPERMANENT': return 'PCD permanente';
      case 'IDOSO': return 'Idoso';
      default: return value;
    }
  }
}
